import axios from 'axios'
import Bridge from '../lib/Bridge'
import { getPlatform } from './getPlatform'

export default () => {
  const _http = axios.create({ withCredentials: true })

  const { isYixinliApp, isZiXunApp, isQingSuApp } = getPlatform()
  if (isYixinliApp || isZiXunApp || isQingSuApp) {
    const getToken = () =>
      new Promise((resolve, reject) => {
        const callbackName =
          'frontend_lib_axios_getToken' +
          +new Date() +
          Math.floor(1000 + Math.random() * 9000) // new Date可能一样导致getToken方法并发部分不执行，加多个四位随机数兜底
        let bridge = new Bridge({
          methods: [
            {
              method: callbackName,
              callback: obj => {
                if (typeof obj === 'object' && !!obj.token) {
                  resolve(obj.token)
                } else {
                  resolve('')
                }
              }
            }
          ]
        })
        bridge.call('getToken', {
          callbackName
        })
      })

    _http.formatEnvInterceptor = _http.interceptors.request.use(res => {
      if (isYixinliApp || isZiXunApp || isQingSuApp) {
        return getToken().then(token => {
          if (res.url.indexOf('?') === -1) {
            res.url += '?token=' + token
          } else {
            res.url += '&token=' + token
          }
          return Promise.resolve(res)
        })
      }
    })
  }

  return _http
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/axios.js